import React from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { Button } from '@odin-labs/components';
import { useGetJobsiteWorkerQuery } from 'apollo/generated/client-operations';
import { NavbarContentProps } from 'routes/types';
import { OnboardingUrlParams } from './types';

export function WorkerOnboardingNavbarContent(
  props: NavbarContentProps,
): React.ReactElement {
  const { currentRoute, pathname } = props;
  const location = useLocation<{ workerOnboardingsQueryParams?: string }>();

  // This navbar is rendered independently of the main component, meaning
  // we can simply grab the first present instance of this state and capture it
  // in a ref, only updating it if the stored value changes to another defined
  // value (i.e. not undefined, as it becomes when the path in react-router changes)
  const workerOnboardingsQueryParams = React.useRef(
    location.state?.workerOnboardingsQueryParams,
  );

  React.useEffect(() => {
    if (location.state?.workerOnboardingsQueryParams)
      workerOnboardingsQueryParams.current =
        location.state?.workerOnboardingsQueryParams;
  }, [location]);

  const currentRoutePath = currentRoute?.path as string;
  const { jobsiteWorkerId } =
    matchPath<OnboardingUrlParams>(pathname, { path: currentRoutePath })
      ?.params ?? {};

  const { data: jobsiteWorkerData } = useGetJobsiteWorkerQuery({
    fetchPolicy: 'no-cache',
    variables: { jobsiteWorkerId },
    skip: !jobsiteWorkerId,
  });

  const { workerId } =
    jobsiteWorkerData?.getJobsiteWorker?.contractorWorker?.worker ?? {};

  return (
    <>
      <div className="odin-grow" />
      <div className="odin-flex odin-justify-end">
        <Button
          as={Link}
          to={`/worker/${workerId}`}
          text="Exit to profile"
          className="odin-mr-1.5 hover:odin-text-white"
        />
        <Button
          as={Link}
          to={`/onboardings${workerOnboardingsQueryParams.current}`}
          text="Exit to onboardings"
          className="hover:odin-text-white"
        />
      </div>
    </>
  );
}
